export const SITE = {
  name: "Sagar Darshan Guest House",
  tagline: "Comfortable stays. Warm hospitality.",
  operator: "Operated by Shree Somnath Trust",
  address: "Prabhas Patan, Somnath, Gujarat 362268, India",
  phoneDisplay: "+91 78915 54163",
  phoneHref: "+917891554163",
  whatsapp: "917891554163",
  email: "info@sagardarsganguesthouse.com",
  checkInTime: "24-hour basis",
  checkOutTime: "24-hour basis",
};

export const waLink = (text) =>
  `https://wa.me/${SITE.whatsapp}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const fmtINR = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const todayISO = () => new Date().toISOString().split("T")[0];

export const addDaysISO = (iso, days) => {
  const d = new Date(iso);
  d.setDate(d.getDate() + days);
  return d.toISOString().split("T")[0];
};

export const nightsBetween = (a, b) =>
  Math.max(0, Math.round((new Date(b) - new Date(a)) / 86400000));
